<div class="home">
  <div class="body">
    <img src="/assets/images/cross-boundary/cb-logo.png" width="400px">
  </div>
</div>
